module.exports = "/dashboard/manage/users/directives/usersTableColumn-16ea36.html";